import {
  FileTextOutlined,
  DollarCircleOutlined,
  InboxOutlined,
  SolutionOutlined,
  CarOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";

export const STATUS_CONFIG = {
  0: { label: "Pedido creado", icon: <FileTextOutlined />, color: "#8c8c8c" },
  1: {
    label: "Pedido pagado",
    icon: <DollarCircleOutlined />,
    color: "#faad14",
  },
  2: { label: "Empaquetado", icon: <InboxOutlined />, color: "#13c2c2" },
  3: {
    label: "Orden de entrega",
    icon: <SolutionOutlined />,
    color: "#722ed1",
  },
  4: { label: "En tránsito", icon: <CarOutlined />, color: "#1890ff" },
  5: { label: "Entregado", icon: <CheckCircleOutlined />, color: "#52c41a" },
};
